import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {TranslateLoader, TranslationObject} from "@ngx-translate/core";
import { getProperties } from 'properties-file'
import {map} from "rxjs/operators";
import unflattenRecord from "../unflattenRecord/unflattenRecord";

const CPropertiesExtension = '.properties';

/**
 * This loader is implemented using https://ngx-translate.org/recipes/write-own-loader/
 * It is a custom loader, freshly implemented and not a copy of the loader of the same name on npm!
 */
export default class NgxTranslateHttpPropertiesLoader implements TranslateLoader {
  constructor(protected http: HttpClient, protected path: string, protected extension: string = CPropertiesExtension) {}

  getTranslation(lang: string): Observable<TranslationObject> {
    const url = [this.path, lang, this.extension].join('');

    if (this.extension !== CPropertiesExtension) {
      return this.http.get(url);
    }

    return this.http.get(url, { responseType: 'text' }).pipe(map(propertiesFile => {
      const propertiesMap = getProperties(propertiesFile);
      return unflattenRecord(propertiesMap);
    }));
  }
}
